export enum TipoNotificacaoCarga {
  NOTIFICAR = 1,
  PRIORIZAR,
}
